module.exports = "../static/media/bg_error_page.cd181f16.png";